import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-loading-libros',
  templateUrl: './loading-libros.component.html',
  styleUrls: ['./loading-libros.component.scss']
})
export class LoadingLibrosComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
